'use client';

import {SignUpForm} from "@/components/Auth/SignUp/SignUp.styled";
import {authApi} from "@/store/api/v1/auth";
import cookieManager from "@/managers/cookie.manager";
import useFormSuccessMutation from "@/hooks/useFormSuccessMutation";
import {useModal} from "@/hooks/useModal";

const SignUpFormAction = ({children}) => {
    const verifyEmail = useModal('verify-email')

    useFormSuccessMutation([authApi, 'register'], (data) => {
        cookieManager.setItem('accessToken', data.token, data.expires)

        verifyEmail.show()
    }, [])

    return (
        <SignUpForm
            // scheme={signUpScheme(te, tf)}
            endpoint={'register'}
            api={authApi}
        >
            {children}
        </SignUpForm>
    )
}


export default SignUpFormAction